import { postData } from './api';
import { ApiEmptyResponse, ResponseData } from './models';

export const cancel = async (): Promise<ResponseData<ApiEmptyResponse>> =>
  postData('api/account/cancel', {});
